import { useEffect, useState } from "react";
import type { PublicConfig } from "@jaiho/shared";
import { getPublicConfig } from "../api/endpoints";
import { GameCard } from "../components/GameCard";
import "./GamesScreen.css";

export function GamesScreen() {
  const [config, setConfig] = useState<PublicConfig | null>(null);

  useEffect(() => {
    void getPublicConfig().then(setConfig);
  }, []);

  const featured = config?.games.filter((g) => g.featured) ?? [];
  const rest = config?.games.filter((g) => !g.featured) ?? [];

  return (
    <div className="jaiho-games">
      <header className="jaiho-games__header">
        <div className="jaiho-games__title">Games</div>
        <div className="jaiho-games__sub">Virtual credits only — nothing here is real-money play.</div>
      </header>

      {featured.length > 0 && (
        <section className="jaiho-games__section">
          <div className="jaiho-games__section-title">Featured</div>
          <div className="jaiho-games__grid">
            {featured.map((game) => (
              <GameCard key={game.id} game={game} />
            ))}
          </div>
        </section>
      )}

      {rest.length > 0 && (
        <section className="jaiho-games__section">
          <div className="jaiho-games__section-title">All Games</div>
          <div className="jaiho-games__grid">
            {rest.map((game) => (
              <GameCard key={game.id} game={game} />
            ))}
          </div>
        </section>
      )}

      {!config && (
        <div className="jaiho-games__grid">
          <div className="jaiho-skeleton jaiho-games__skeleton" />
          <div className="jaiho-skeleton jaiho-games__skeleton" />
        </div>
      )}
    </div>
  );
}
